export const bugFixGuide = {
  "title": "How to verify a bug fix with before and after recordings",
  "slug": "verify-bug-fix-before-after-recordings",
  "date": "2026-10-14",
  "description": "Verify a bug fix with the same steps on old and new builds. Capture before and after recordings, check for regressions, and share clear evidence in your PR."
} as const;
